// ScrollToTop.jsx
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../lib/metaPixel";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const isFirstRoute = useRef(true);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  // This is a react-router SPA: moving between pages swaps components without a
  // document load, so the pixel's one-shot PageView in index.html never fires
  // again. Without this, a visitor who lands on / and then browses five pages
  // counts as a single PageView.
  useEffect(() => {
    // Skip the route we arrived on -- index.html already counted it.
    if (isFirstRoute.current) {
      isFirstRoute.current = false;
      return;
    }
    trackPageView();
  }, [pathname]);

  return null;
};

export default ScrollToTop;
